interface IProps {
  width?: number
  height?: number
}

const HapVida = ({ width, height }: IProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      version='1.1'
      viewBox='0 0 700 700'
      xmlSpace='preserve'
    >
      <defs>
        <clipPath clipPathUnits='userSpaceOnUse'>
          <path d='M1.98 790.02H612V.03H1.98z'></path>
        </clipPath>
        <clipPath clipPathUnits='userSpaceOnUse'>
          <path d='M201.06 596.52H411v-53.88H201.06z'></path>
        </clipPath>
      </defs>
      <g transform='matrix(1.33333 0 0 -1.33333 0 700)'>
        <g transform='translate(362.487 282.638) scale(1.91875)'>
          <path
            fill='#2f6abc'
            fillOpacity='1'
            fillRule='nonzero'
            stroke='none'
            d='M0 0c.095.569.255 1.212.225 1.555-.027.526-.132 1.051-.387 1.266-.486.433-1.236.842-2.317.842-2.458 0-3.927-.197-3.927-.197l-.613-2.67-.386-1.718s1.092-.345 3.558-.345c2.329 0 3.645.324 3.645.324L0 0'
          ></path>
        </g>
        <g transform='translate(354.55 278.476) scale(1.91875)'>
          <path
            fill='#2f6abc'
            fillOpacity='1'
            fillRule='nonzero'
            stroke='none'
            d='M0 0c-2.475 0-3.68-.345-3.68-.345l-3.033-13.186-2.118-9.19a5.097 5.097 0 012.724-.905h.243a5.083 5.083 0 014.347 2.543c.203.353.369.723.48 1.114.062.17.094.276.094.276L3.498-.345S2.285 0 0 0'
          ></path>
        </g>
        <g transform='translate(227.38 243.175) scale(1.91875)'>
          <path
            fill='#2f6abc'
            fillOpacity='1'
            fillRule='nonzero'
            stroke='none'
            d='M0 0c-.102-.01-.206-.01-.314-.01-2.524 0-3.453 1.241-2.24 6.524 1.257 5.46 2.797 6.746 5.321 6.746 2.054 0 2.939-1.501 2.519-3.564L4.274 5.281l-.388-1.682C3.401 1.638 1.943.146 0 0zm10.682 18.125c-2.287 0-3.523-.535-3.523-.535l-.303-1.301c-1.171 1.674-2.641 2.127-5.351 2.127-5.413 0-9.384-2.456-11.396-11.217-2.048-8.761.747-12.4 5.983-12.4 2.356 0 4.16.634 5.619 1.655.385.284.418.292.688.507l-.296-1.284c.143-.07.969-.495 1.248-.595a4.986 4.986 0 011.69-.299c.319 0 .627.035.928.092a5.064 5.064 0 013.471 2.43c.241.401.413.833.533 1.294.015.046.032.119.032.119l4.374 18.883s-1.412.524-3.697.524'
          ></path>
        </g>
        <g transform='translate(281.78 255.757) scale(1.91875)'>
          <path
            fill='#2f6abc'
            fillOpacity='1'
            fillRule='nonzero'
            stroke='none'
            d='M0 0c-1.302-5.634-2.937-6.665-5.275-6.665-1.978 0-2.792 1.439-2.607 3.274.025.255.067.507.129.76l1.121 4.856.14.607c.608 2.28 2.242 3.781 4.298 3.781C.241 6.613 1.259 5.411 0 0zm1.676 11.814c-2.796 0-4.944-.781-6.576-2.192l.328 1.411s-1.266.535-3.55.535c-2.296 0-3.649-.524-3.649-.524l-1.963-8.54-.064-.268c-.112-.488-.329-1.441-.329-1.448l-.412-1.763-3.765-16.353-.252-1.105c.145-.069.97-.496 1.249-.594a4.937 4.937 0 011.696-.291c.313 0 .62.026.919.081a5.126 5.126 0 013.476 2.434c.235.407.414.829.531 1.301.012.037.032.12.032.12l.352 1.509.12.532.841 3.718c.002-.009.008-.017.011-.017.987-1.413 2.71-2.179 5.5-2.179 5.185 0 9.342 2.623 11.348 11.431 2.059 8.935-.788 12.202-5.843 12.202'
          ></path>
        </g>
        <g transform='translate(329.932 277.795) scale(1.91875)'>
          <path
            fill='#2f6abc'
            fillOpacity='1'
            fillRule='nonzero'
            stroke='none'
            d='M0 0l-6.991-17.327a.105.105 0 00-.202.045h.003-.003l-.345 6.458-.858 10.371s-1.137.528-3.515.528c-2.25 0-3.708-.528-3.708-.528l2.811-22.383c1.773-.309 4.087-.445 5.94-.453.31.008.613.019.891.038a5.083 5.083 0 013.154 1.704c.059.058.111.131.167.194a15.573 15.573 0 011.628 2.524L6.919 0S5.798.355 3.641.355C1.636.355 0 0 0 0'
          ></path>
        </g>
        <g transform='translate(194.969 277.849) scale(1.91875)'>
          <path
            fill='#2f6abc'
            fillOpacity='1'
            fillRule='nonzero'
            stroke='none'
            d='M0 0c-2.469 0-4.827-.832-6.734-2.207l1.092 4.759v.016l.18.733c.029.099.055.206.072.316a3.101 3.101 0 01-.137 1.595 3.155 3.155 0 01-2.894 2.094h-.29c-2.059-.043-3.091-.333-3.091-.333l-.45-1.979-1.199-5.138-5.154-22.295c.183-.088.958-.496 1.227-.59a4.816 4.816 0 011.236-.269c.018 0 .039-.01.055-.01h.226c.037 0 .073-.009.111-.009h.27c.246.009.483.038.721.086a5.071 5.071 0 013.468 2.42c.023.046.045.091.069.136a.389.389 0 01.044.089c.161.353.293.708.372.916.012.037.028.08.039.124a.614.614 0 00.023.075l2.132 9.243.724 3.156.123.534c1.121.777 2.332 1.202 3.503 1.202 2.145 0 2.751-.985 2.378-2.579L-5.207-22.42v-.019c.16-.082.959-.496 1.229-.59a4.904 4.904 0 011.244-.269c.206-.01.423-.019.655-.019.245.009.486.038.723.086a5.08 5.08 0 013.467 2.42c.027.046.047.091.071.136.196.355.346.732.451 1.129.018.048.023.075.023.075l2.83 12.253C6.414-3.102 4.766 0 0 0'
          ></path>
        </g>
        <g transform='translate(390.108 260.841) scale(1.91875)'>
          <path
            fill='#2f6abc'
            fillOpacity='1'
            fillRule='nonzero'
            stroke='none'
            d='M0 0l-.999-4.339-.254-1.114a7.354 7.354 0 00-.133-.432c-.664-1.937-2.103-3.212-3.898-3.332-.085-.005-.173-.005-.262-.005-2.421 0-3.453 1.2-2.192 6.609 1.308 5.616 2.937 6.647 5.269 6.647C-.43 4.034.37 2.516.114.598A5.372 5.372 0 000 0zm9.984 14.192a3.157 3.157 0 01-2.594 2.071 1.912 1.912 0 01-.299.026h-.288c-1.381-.037-2.298-.171-2.753-.26-.225-.046-.336-.075-.336-.075l-.456-1.987-1.664-6.974c-.985 1.42-2.71 2.19-5.504 2.19-5.179 0-9.335-2.616-11.336-11.409-2.053-8.924.791-12.189 5.829-12.189 2.278 0 4.122.516 5.612 1.474.331.217.654.444.949.696.006.008.015.008.021.02l-.302-1.276a5.136 5.136 0 012.941-.932c1.378 0 2.629.553 3.549 1.446.039.027.074.066.115.11.036.037.065.073.099.108a5.03 5.03 0 011.148 2.08.142.142 0 00.015.035l.044.19.026.119L8.035 3.817l.132.572.711 3.063.786 3.086s.079.279.148.711l.235 1.026a3.016 3.016 0 01.122.857c0 .372-.067.733-.185 1.06'
          ></path>
        </g>
        <g transform='translate(426.549 243.175) scale(1.91875)'>
          <path
            fill='#2f6abc'
            fillOpacity='1'
            fillRule='nonzero'
            stroke='none'
            d='M0 0c-.103-.01-.209-.01-.314-.01-2.527 0-3.452 1.241-2.241 6.524 1.258 5.46 2.801 6.746 5.322 6.746 2.055 0 2.938-1.501 2.52-3.564L4.271 5.281l-.387-1.682C3.401 1.638 1.943.146 0 0zm10.682 18.125c-2.291 0-3.524-.535-3.524-.535l-.301-1.301c-1.172 1.674-2.642 2.127-5.352 2.127-5.416 0-9.384-2.456-11.396-11.217-2.048-8.761.747-12.4 5.98-12.4 2.359 0 4.163.634 5.621 1.655.39.284.419.292.689.507l-.293-1.284c.14-.07.964-.495 1.245-.595a4.973 4.973 0 011.693-.299c.316 0 .624.035.922.092a5.074 5.074 0 014.037 3.843l4.376 18.883s-1.412.524-3.697.524'
          ></path>
        </g>
        <g transform='translate(104.788 226.465) scale(1.91875)'>
          <path
            fill='#fab20b'
            fillOpacity='1'
            fillRule='nonzero'
            stroke='none'
            d='M0 0c0 2.343 2.148 9.5 4.811 9.5C7.464 9.5 9.62 2.343 9.62 0c0-2.36-2.156-4.276-4.809-4.276C2.148-4.276 0-2.36 0 0'
          ></path>
        </g>
        <g transform='translate(114.02 306.74) scale(1.91875)'>
          <path
            fill='#ef2f2c'
            fillOpacity='1'
            fillRule='nonzero'
            stroke='none'
            d='M0 0c-3.896 0-7.055-3.09-7.055-6.91 0-3.804 3.159-16.213 7.055-16.213 3.894 0 7.055 12.409 7.055 16.213C7.055-3.09 3.894 0 0 0'
          ></path>
        </g>
        <g transform='translate(77.115 260.736) scale(1.91875)'>
          <path
            fill='#f1471d'
            fillOpacity='1'
            fillRule='nonzero'
            stroke='none'
            d='M0 0c3.036-1.671 13.604-4.248 15.269-1.219C16.941 1.81 9.082 9.31 6.036 10.974a6.28 6.28 0 01-8.521-2.471A6.255 6.255 0 010 0'
          ></path>
        </g>
        <g transform='translate(155.728 276.583) scale(1.91875)'>
          <path
            fill='#f1471d'
            fillOpacity='1'
            fillRule='nonzero'
            stroke='none'
            d='M0 0a6.274 6.274 0 01-8.52 2.468c-3.043-1.664-10.902-9.159-9.231-12.19 1.668-3.032 12.235-.454 15.27 1.22A6.252 6.252 0 010 0'
          ></path>
        </g>
        <g transform='translate(84.854 238.787) scale(1.91875)'>
          <path
            fill='#f47216'
            fillOpacity='1'
            fillRule='nonzero'
            stroke='none'
            d='M0 0a3.838 3.838 0 015.129-1.817c1.927.901 7.014 5.234 6.093 7.132-.913 1.919-7.481.708-9.397-.187A3.85 3.85 0 010 0'
          ></path>
        </g>
        <g transform='translate(139.707 248.626) scale(1.91875)'>
          <path
            fill='#f47216'
            fillOpacity='1'
            fillRule='nonzero'
            stroke='none'
            d='M0 0c-1.928.894-8.497 2.115-9.42.187-.905-1.899 4.18-6.231 6.101-7.133a3.857 3.857 0 015.146 1.818C2.738-3.21 1.913-.922 0 0'
          ></path>
        </g>
      </g>
    </svg>
  )
}

export default HapVida
